// ─── Filter framework: saved-filter colours (f-02062) ─────────────
// A saved filter may carry ONE colour key from this fixed palette. Only the
// KEY is stored, never a hex: the web resolves it to the theme tokens
// --filter-color-<key> and --filter-color-<key>-soft, which apps/web/src/
// index.css defines in EVERY theme block (all five palettes, light + dark).
// The colour tints the filter's icon on pills, tabs, the Filters menu and the
// save sheet; in text-only display a small dot in the colour precedes the name.
// 'none' means "no colour": the icon inherits currentColor.
export const FILTER_COLOR_KEYS = [
    'none', 'slate', 'red', 'orange', 'amber', 'green', 'teal', 'cyan', 'blue', 'violet', 'pink',
];
export const DEFAULT_FILTER_COLOR = 'none';
export const FILTER_COLOR_LABELS = {
    none: { en: 'No colour', da: 'Ingen farve' },
    slate: { en: 'Slate', da: 'Skifer' },
    red: { en: 'Red', da: 'Rød' },
    orange: { en: 'Orange', da: 'Orange' },
    amber: { en: 'Amber', da: 'Rav' },
    green: { en: 'Green', da: 'Grøn' },
    teal: { en: 'Teal', da: 'Blågrøn' },
    cyan: { en: 'Cyan', da: 'Cyan' },
    blue: { en: 'Blue', da: 'Blå' },
    violet: { en: 'Violet', da: 'Violet' },
    pink: { en: 'Pink', da: 'Pink' },
};
const COLOR_SET = new Set(FILTER_COLOR_KEYS);
export function isFilterColorKey(v) {
    return typeof v === 'string' && COLOR_SET.has(v);
}
/** Coerce stored/untrusted input to a palette key ('none' when unknown). */
export function coerceFilterColor(v) {
    return isFilterColorKey(v) ? v : DEFAULT_FILTER_COLOR;
}
/** CSS custom-property NAMES for a key, or null for 'none'. */
export function filterColorTokenName(key) {
    return key === 'none' ? null : `--filter-color-${key}`;
}
export function filterColorSoftTokenName(key) {
    return key === 'none' ? null : `--filter-color-${key}-soft`;
}
/** `var(--filter-color-<key>)` for inline styles, or undefined for 'none'
 *  (so the element keeps inheriting currentColor). */
export function filterColorVar(key) {
    const name = key ? filterColorTokenName(key) : null;
    return name ? `var(${name})` : undefined;
}
export function filterColorSoftVar(key) {
    const name = key ? filterColorSoftTokenName(key) : null;
    return name ? `var(${name})` : undefined;
}
//# sourceMappingURL=colors.js.map